export interface IState {
  timesheetList: any;
  timesheetCount: number;
  innerJobList: any;
  timesheetLogList: any;
  timesheetLogCount: any;
  checkoutHistory: any;
  checkoutHistoryCount: number;
  timesheetJobCodeCounts: any;
  timesheetEmploye: any;
  timeLogTimeSheetDetails: any;
  timesheetTaskLogList: any;
  taskTimeSheetWorkdedHors: any;
  availablePto: any;
  availableHoliday: any;
  userHaveBenefites: any;
}

type Action = any;

export const timesheetsReducer = (
  state: IState = {
    timesheetList: [],
    timesheetCount: 0,
    innerJobList: [],
    timesheetLogList: [],
    timesheetLogCount: 0,
    checkoutHistory: [],
    checkoutHistoryCount: 0,
    timesheetJobCodeCounts: {},
    timesheetEmploye: {},
    timeLogTimeSheetDetails: {},
    timesheetTaskLogList: [],
    taskTimeSheetWorkdedHors: {
      totalWorkingHours: 0,
      totalWorkingMinutes: 0,
    },
    availablePto: 0,
    availableHoliday: 0,
    userHaveBenefites: false,
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_TIMESHEETS":
      return {
        ...state,
        timesheetList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.timesheetList, ...action?.payload?.data],
        timesheetCount: action?.payload?.count,
      };
    case "GET_INNER_JOB": {
      return {
        ...state,
        innerJobList: action?.payload,
      };
    }
    case "GET_TIMESHEETS_LOG":
      return {
        ...state,
        timesheetLogList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.timesheetLogList, ...action?.payload?.data],
        timesheetLogCount: action?.payload?.count,
        timesheetJobCodeCounts: action?.payload?.JobCodeCounts[0]?.counts ?? {},
        timesheetEmploye: action?.payload?.employee,
        timeLogTimeSheetDetails: action?.payload?.timesheet,
        availablePto: action?.payload?.availablePto,
        availableHoliday: action?.payload?.availableHoliday,
        userHaveBenefites: action?.payload?.is_have_banefits,
      };
    case "GET_TIMESHEETS_Task_LOG":
      return {
        ...state,
        timesheetTaskLogList:
          action?.payload?.page == 1
            ? action?.payload?.data
            : [...state?.timesheetTaskLogList, ...action?.payload?.data],
        taskTimeSheetWorkdedHors: action?.payload?.workedHours,
      };

    case "CLEAR_TIMESHEET_TASK_LOG":
      return {
        ...state,
        timesheetTaskLogList: [],
        taskTimeSheetWorkdedHors: {
          totalWorkingHours: 0,
          totalWorkingMinutes: 0,
        },
      };
    case "GET_CHECKOUT_HISTORY":
      return {
        ...state,
        checkoutHistory:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.checkoutHistory, ...action?.payload?.data],
        checkoutHistoryCount: action?.payload?.count,
      };

    case "EDIT_TIMESHEET_LOG_UPDATE":
      return {
        ...state,
        timesheetTaskLogList: state?.timesheetTaskLogList?.map((elem: any) => {
          if (elem?._id == action.payload.id) {
            return action.payload?.data;
          }
          return elem;
        }),
        taskTimeSheetWorkdedHors: action.payload?.data?.total,
      };
    case "CHANGE_TIMESHEET_STATUS":
      return {
        ...state,
        timesheetList: state?.timesheetList?.map((elem: any) => {
          if (
            action?.payload?.data?.timesheets?.includes(elem?._id) &&
            !action?.payload?.blockedId?.includes(elem?._id)
          ) {
            return {
              ...elem,
              status: action?.payload?.data?.status,
            };
          }
          return elem;
        }),
      };
    default:
      return state;
  }
};
